import { render, staticRenderFns } from "./DeleteEvent.vue?vue&type=template&id=6f2ba800&scoped=true&lang=pug&"
import script from "./DeleteEvent.vue?vue&type=script&lang=js&"
export * from "./DeleteEvent.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEvent.vue?vue&type=style&index=0&id=6f2ba800&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2ba800",
  null
  
)

export default component.exports